import { render } from "./EnbProdImg.vue?vue&type=template&id=3281a40b&scoped=true"
import script from "./EnbProdImg.vue?vue&type=script&lang=js"
export * from "./EnbProdImg.vue?vue&type=script&lang=js"

import "./EnbProdImg.vue?vue&type=style&index=0&id=3281a40b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3281a40b"]])

export default __exports__